export enum SessionMode {
  Unknown = 'Unknown',
  SessionStarted = 'SessionStarted',
  WarmupStarted = 'WarmupStarted',
  PlayingStarted = 'PlayingStarted',
  SessionEnded = 'SessionEnded',
}
